import c0 from './dispositivo_utilizador_controller';
export const definitions = [
	{identifier: 'dispositivo-utilizador', controllerConstructor: c0},
];
